import { createContext, useState, useEffect } from "react";
import { io } from "socket.io-client";
import axios from "../AxiosInstance"; // Adjust the import path as necessary
import { BASE_URL_Socket } from "../config/BaseUrls";

export const NotificationContext = createContext();
export const NotificationProvider = ({ children }) => {
    const userData = JSON.parse(localStorage.getItem("auth"));
    const [notifications, setNotifications] = useState([]);

    
    const fetchNotifications = async () => {
        try {
            const res = await axios.get(`/api/v1/admin/notifications/${userData?.user?._id}`);
            if (res.data.success) {
                // Ensure notifications are sorted by createdAt (newest first)
                // Backend already sorts, but we'll ensure it here too
                const sortedNotifications = [...(res.data.notifications || [])].sort((a, b) => {
                    const dateA = new Date(a.createdAt || a.timestamp || 0);
                    const dateB = new Date(b.createdAt || b.timestamp || 0);
                    return dateB - dateA; // Newest first
                });
                setNotifications(sortedNotifications);
            }
        } catch (error) {
            console.error("❌ Error fetching notifications:", error);
        }
    };

    useEffect(() => {
        if (userData?.user?._id) {
            fetchNotifications();
        }
    }, [userData?.user?._id]);

    return (
        <NotificationContext.Provider value={{ notifications, setNotifications }}>
            {children}
        </NotificationContext.Provider>
    );
};
